import {path, is, prop, either} from 'ramda';
import moment from 'moment';
import {isBypassAlarm} from './alarms.js';

const isNumber = is(Number);

export const getLocalTime = system => {
  const offset = path(['location', 'timezone'], system);
  if (!isNumber(offset)) {
    return 'N/A';
  }
  const area = system.area ? ` (${system.area})` : '';
  return (
    moment()
    .utcOffset(offset * 60)
    .format('LTS Z') + area
  );
};

export const hasDowntime = system => [1, 2].includes(system.downtime);

export const hasBypass = system => Array.isArray(system.alarms) && system.alarms.some(isBypassAlarm);

export const hasCriticalAlarm = prop('alarmCategory');

export const hasCriticalAlarmOrBypass = either(hasCriticalAlarm, hasBypass);
